module.exports = __webpack_public_path__ + "static/img/170903-ultrasound.95ed63b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/170903-ultrasound.jpg
// module id = kUA4
// module chunks = 0